var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrownCup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10679_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2706 24.4775H18.8293V33.0861H21.2706V24.4775Z",
    fill: "#D47731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5677 6.3042H2.03857C2.03857 12.1428 2.48633 15.5013 10.8051 15.5013",
    stroke: "#DE9B67",
    strokeWidth: 3.07692
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0594 13.9512C31.0594 20.058 26.109 25.0085 20.0022 25.0085C13.8955 25.0085 8.94507 20.058 8.94507 13.9512C8.94507 7.84452 13.8955 2.89404 20.0022 2.89404C26.109 2.89404 31.0594 7.84452 31.0594 13.9512Z",
    fill: "#DE9B67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.002 32.6558C15.4934 32.6558 11.8384 33.9744 11.8384 35.601H28.1659C28.1659 33.9744 24.5108 32.6558 20.002 32.6558Z",
    fill: "#DE9B67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.94507 0.769043H31.0594V13.4346H8.94507V0.769043Z",
    fill: "#DE9B67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1659 36.1693H11.8384V35.5493H28.1659V36.1693Z",
    fill: "#DE9B67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7467 6.3042H38.2757C38.2757 12.1428 37.828 15.5013 29.5093 15.5013",
    stroke: "#D47B37",
    strokeWidth: 3.07692
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0589 13.9513C31.0589 20.058 26.1085 25.0084 20.0017 25.0084C20.0017 25.0084 20.0017 20.058 20.0017 13.9513C20.0017 7.84452 20.0017 2.89404 20.0017 2.89404C26.1085 2.89404 31.0589 7.84452 31.0589 13.9513Z",
    fill: "#D47B37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0017 32.6558C20.0017 32.6558 20.0017 33.9744 20.0017 35.6008H28.1654C28.1654 33.9744 24.5105 32.6558 20.0017 32.6558Z",
    fill: "#D47B37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0017 0.77002H31.0589V13.4348H20.0017V0.77002Z",
    fill: "#D47B37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1655 36.1692H20.0018C20.0018 36.1692 19.9835 35.7906 20.0018 35.5491C20.2432 32.3702 28.1655 35.5491 28.1655 35.5491V36.1692Z",
    fill: "#D47B37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.331 12.721C23.331 14.4397 21.9378 15.833 20.219 15.833C18.5003 15.833 17.1071 14.4397 17.1071 12.721C17.1071 11.0023 18.5003 9.609 20.219 9.609C21.9378 9.609 23.331 11.0023 23.331 12.721Z",
    fill: "#DE9B67",
    stroke: "#DE9B67",
    strokeWidth: 7.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2057 7.19922L21.8822 10.5522L25.2351 10.9713L22.9327 13.553L23.5587 17.2581L20.2057 15.5816L16.8528 17.2581L17.4842 13.553L15.1763 10.9713L18.5293 10.5522L20.2057 7.19922Z",
    fill: "#DE9B67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8939 6.85505L20.2059 5.479L19.5177 6.85505L18.0254 9.83976L15.081 10.2078L13.625 10.3898L14.6029 11.4838L16.6637 13.7891L16.0946 17.1287L15.8396 18.6245L17.197 17.9459L20.2059 16.4415L23.2148 17.9459L24.5696 18.6233L24.3173 17.1298L23.753 13.7891L25.8093 11.4831L26.7845 10.3896L25.3306 10.2078L22.3862 9.83976L20.8939 6.85505Z",
    stroke: "#D88444",
    strokeWidth: 1.53846
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2693 36.1538H8.19238V39.2307H31.2693V36.1538Z",
    fill: "#D47731"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10679_1377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrownCup);
export default __webpack_public_path__ + "static/media/brown-cup.c36e8841170c9ecbbc8c94f61b0b37ec.svg";
export { ForwardRef as ReactComponent };